module.exports = __webpack_public_path__ + "img/league-of-legends.eccb419f.png";